import { AxiosResponse } from "axios";
import { container, injectable } from "tsyringe";
import { CredentialsDTO } from "../Dto/CredentialsDTO";
import { IAuthService, IHttpService } from "frontend-core";
import { ValidationException } from "@/models/ValidationException";
import { ILoginService } from "./ILoginService";

/**
 * Currently is used to contain a modified copy of the same login method from frontend-core,
 * because methods to login will differ in different projects.
 */
@injectable()
export class LoginService implements ILoginService {
  private readonly authService: IAuthService = container.resolve(
    "IAuthService",
  );
  private readonly httpService: IHttpService = container.resolve(
    "IHttpService",
  );

  public async login(dto?: CredentialsDTO): Promise<AxiosResponse> {
    if (!dto?.validate) {
      throw new ValidationException("dto is not valid");
    }
    const res = await this.httpService.api.post("/login", dto.serialize());
    if (!res.data.token && res.data.success) {
      return res;
    }
    this.authService.credentials = {
        mercureToken: res.data.mercure_token,
        refreshToken: res.data.refresh_token,
        token: res.data.token,
      };
    return res;
  }
}
